/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */
import type {
  FacilityFlowCoreModulesOffersDtosOfferDto,
  FacilityFlowCoreModulesOffersWorkflowsChangeOfferStatusRequest,
  FacilityFlowCoreModulesOffersWorkflowsCreateOfferRequest,
  FacilityFlowCoreModulesOffersWorkflowsCreateOfferResponse,
  FacilityFlowCoreModulesOffersWorkflowsRenderOfferSnippetRequest,
  FacilityFlowCoreModulesOffersWorkflowsRenderOfferSnippetResponse,
  FacilityFlowCoreModulesOffersWorkflowsSearchOffersResponse,
  FacilityFlowCoreModulesOffersWorkflowsUpdateOfferRequest,
  GetApiV1OffersParams
} from '.././models';

import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getOffers = () => {
/**
 * @summary Search offers with optional filters
 */
const getApiV1Offers = (
    params?: GetApiV1OffersParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesOffersWorkflowsSearchOffersResponse>>,) => {
      return customInstance<FacilityFlowCoreModulesOffersWorkflowsSearchOffersResponse>(
      {url: `/api/v1/offers`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Create a new offer (status: Draft)
 */
const postApiV1Offers = (
    facilityFlowCoreModulesOffersWorkflowsCreateOfferRequest: FacilityFlowCoreModulesOffersWorkflowsCreateOfferRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesOffersWorkflowsCreateOfferResponse>>,) => {
      return customInstance<FacilityFlowCoreModulesOffersWorkflowsCreateOfferResponse>(
      {url: `/api/v1/offers`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesOffersWorkflowsCreateOfferRequest
    },
      options);
    }
  /**
 * @summary Get offer by ID with all positions
 */
const getApiV1OffersId = (
    id: string,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesOffersDtosOfferDto>>,) => {
      return customInstance<FacilityFlowCoreModulesOffersDtosOfferDto>(
      {url: `/api/v1/offers/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Update an existing offer. Allowed while the offer is a draft and after it was
accepted, but only until an invoice references it.
 */
const putApiV1OffersId = (
    id: string,
    facilityFlowCoreModulesOffersWorkflowsUpdateOfferRequest: FacilityFlowCoreModulesOffersWorkflowsUpdateOfferRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesOffersDtosOfferDto>>,) => {
      return customInstance<FacilityFlowCoreModulesOffersDtosOfferDto>(
      {url: `/api/v1/offers/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesOffersWorkflowsUpdateOfferRequest
    },
      options);
    }
  /**
 * @summary Delete an offer (Draft only)
 */
const deleteApiV1OffersId = (
    id: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/offers/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * @summary Create a new draft offer from an existing one, carrying over all positions.
Used to supersede an offer that is frozen because an invoice references it.
The successor becomes the object's active offer once it is accepted.
 */
const postApiV1OffersIdDuplicate = (
    id: string,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesOffersDtosOfferDto>>,) => {
      return customInstance<FacilityFlowCoreModulesOffersDtosOfferDto>(
      {url: `/api/v1/offers/${id}/duplicate`, method: 'POST'
    },
      options);
    }
  /**
 * @summary Change offer status (Draft -> Sent -> Accepted/Rejected/Expired)
 */
const putApiV1OffersIdStatus = (
    id: string,
    facilityFlowCoreModulesOffersWorkflowsChangeOfferStatusRequest: FacilityFlowCoreModulesOffersWorkflowsChangeOfferStatusRequest,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/offers/${id}/status`, method: 'PUT',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesOffersWorkflowsChangeOfferStatusRequest
    },
      options);
    }
  /**
 * @summary Generate offer PDF document
 */
const getApiV1OffersIdPdf = (
    id: string,
 options?: SecondParameter<typeof customInstance<Blob>>,) => {
      return customInstance<Blob>(
      {url: `/api/v1/offers/${id}/pdf`, method: 'GET',
        responseType: 'blob'
    },
      options);
    }
  /**
 * @summary Render a text snippet body (e.g. for live preview when a snippet is picked in the offer form).
Replaces placeholders like {CustomerName}, {OfferDate} with values from the provided context.
 */
const postApiV1OffersRenderSnippet = (
    facilityFlowCoreModulesOffersWorkflowsRenderOfferSnippetRequest: FacilityFlowCoreModulesOffersWorkflowsRenderOfferSnippetRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesOffersWorkflowsRenderOfferSnippetResponse>>,) => {
      return customInstance<FacilityFlowCoreModulesOffersWorkflowsRenderOfferSnippetResponse>(
      {url: `/api/v1/offers/render-snippet`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesOffersWorkflowsRenderOfferSnippetRequest
    },
      options);
    }
  return {getApiV1Offers,postApiV1Offers,getApiV1OffersId,putApiV1OffersId,deleteApiV1OffersId,postApiV1OffersIdDuplicate,putApiV1OffersIdStatus,getApiV1OffersIdPdf,postApiV1OffersRenderSnippet}};
export type GetApiV1OffersResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getOffers>['getApiV1Offers']>>>
export type PostApiV1OffersResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getOffers>['postApiV1Offers']>>>
export type GetApiV1OffersIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getOffers>['getApiV1OffersId']>>>
export type PutApiV1OffersIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getOffers>['putApiV1OffersId']>>>
export type DeleteApiV1OffersIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getOffers>['deleteApiV1OffersId']>>>
export type PostApiV1OffersIdDuplicateResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getOffers>['postApiV1OffersIdDuplicate']>>>
export type PutApiV1OffersIdStatusResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getOffers>['putApiV1OffersIdStatus']>>>
export type GetApiV1OffersIdPdfResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getOffers>['getApiV1OffersIdPdf']>>>
export type PostApiV1OffersRenderSnippetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getOffers>['postApiV1OffersRenderSnippet']>>>
